export default __webpack_public_path__ + "static/media/logoClassfy.dc277f62.png";